import gql from 'graphql-tag';

export default gql`
    query locationSuggestion($input: String!) {
        viewer {
            id,
            locationSuggestion(input: $input) {
                street
            }
        }
    }
`;
